import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ApiService from '../../services/ApiService';
import Form from '../form/Form';
import LoadingPage from '../LoadingPage';
import FileNotFound from '../FileNotFound';
import toastr from '../toastr';

const getLayout = ({ userLayouts, publicLayouts, currentLayoutId }) => {
  return [
    {
      control: 'ReactSelect',
      name: 'layoutId',
      label: 'Layouts',

      data: currentLayoutId,

      options: [
        {
          key: 'default',
          options: [
            {
              key: 'default-label',
              label: (
                <div key="default">
                  <span className="text-bold">Default</span> - No Custom Layout
                </div>
              ),
              value: '',
            },
          ],
        },
        {
          key: 'my',
          label: 'My Layouts',
          options: userLayouts.map(layout => {
            return {
              key: String(layout.id),
              label: (
                <div key={`${String(layout.id)}-label`}>
                  <span className="text-bold">{layout.name}</span>
                  {!!layout.description && ` - ${layout.description}`}
                </div>
              ),
              value: String(layout.id),
            };
          }),
        },
        {
          key: 'pub',
          label: 'Public Layouts',
          options: publicLayouts.map(layout => {
            return {
              key: String(layout.id),
              label: (
                <div key={`${String(layout.id)}-label`}>
                  <span className="text-bold">{layout.name}</span> ({layout.User.username})
                  {!!layout.description && ` - ${layout.description}`}
                </div>
              ),
              value: String(layout.id),
            };
          }),
        },
      ],
    },
  ];
};

const LoadGridLayoutForm = ({ pageName, optionsHash = null, currentLayoutId, onSubmit, ...props }) => {
  const [userLayouts, setUserLayouts] = useState(null);
  const [publicLayouts, setPublicLayouts] = useState(null);

  useEffect(() => {
    Promise.all([
      ApiService.get('grid-layouts', { params: { pageName, optionsHash } }),
      ApiService.get('grid-layouts', { params: { isPublic: 1, pageName, optionsHash } }),
    ]).then(result => {
      const userLayoutIds = (result[0].data || []).map(x => x.id);
      setUserLayouts(result[0].data);
      setPublicLayouts(result[1].data.filter(x => !userLayoutIds.includes(x.id)));
    });
  }, []);

  const handleSubmit = ({ layoutId }) => {
    ApiService.post('user-grid-layouts', { pageName, optionsHash, layoutId })
      .then(() => {
        for (const layout of [...userLayouts, ...publicLayouts]) {
          if (layout.id === Number(layoutId)) {
            onSubmit(layout);
            return;
          }
        }

        onSubmit();
      })
      .catch(err => {
        toastr.error(err.message);
      });
  };

  if (!userLayouts || !publicLayouts) {
    return <LoadingPage />;
  }

  if (!userLayouts.length && !publicLayouts.length) {
    return <FileNotFound message={`No Layouts Found for ${pageName}`} />;
  }

  return (
    <Form
      {...props}
      layout={getLayout({ userLayouts, publicLayouts, currentLayoutId })}
      submit={handleSubmit}
      exportFormat="object"
      submitAll
      useDirtyWarning={false}
      trackDirty={false}
    />
  );
};

LoadGridLayoutForm.propTypes = {
  currentLayoutId: PropTypes.number,
  onSubmit: PropTypes.func,
  optionsHash: PropTypes.string,
  pageName: PropTypes.string,
};

export default LoadGridLayoutForm;
